import React from "react";

const LuniShowerPageHeader = () => {
  // Header vide pour l'instant, peut être enrichi plus tard
  return null;
};

export default LuniShowerPageHeader;
